import options from '../../../../../constants/carouselOptions.js';
import defaultAlignment from './defaultAlignment.js';
import corporate from './corporate.js';
import fullWidth from './fullWidth.js';

/**
 * It returns the alignment according to the predefined variation.
 * The predefined variation is selected from the "Pre-defined Variation" value "Carousel Options" entry.
 * @param {*} variation 
 * @returns 
 */
var variationHandler = function variationHandler(variation) {
  switch (variation) {
    case options.VARIATION.CORPORATE:
      return corporate();
    case options.VARIATION.FULL_WIDTH:
      return fullWidth();
    case options.VARIATION.DEFAULT:
    default:
      return defaultAlignment();
  }
};
export default variationHandler;